import { useSelector } from 'react-redux';
import { PapiGallection } from '@wix/da-papi-types';
import { normalizePremiumFolderData } from '@wix/da-shared-react/pkg/utils/normalizePremiumFolderData';
import { getFeaturedFolderId } from '../selectors/studio';

export const useCanCreateSubfolder = (folder?: PapiGallection) => {
  const featuredFolderId = useSelector(getFeaturedFolderId);
  const isRootFolder = !folder?.parentId;
  const isFeaturedFolder = folder?.folderId === featuredFolderId;
  const { isPremium, isPaidFolder, isWatchToAccess } = normalizePremiumFolderData(
    folder?.premiumFolderData
  );

  return isRootFolder && !isFeaturedFolder && !isPaidFolder && !isWatchToAccess && !isPremium;
};

export default useCanCreateSubfolder;
